const columns = [{
    title: 'Nome',
    searchName: "nome",
    dataIndex: 'name',
    key: 'name',
    width: '80%',
    sortKind: "string"
},{
    title: 'Ação',
    dataIndex: 'uf',
    key: 'action',
    width: '20%'
}];

export default columns;


// WEBPACK FOOTER //
// ./src/const/columns/branch.js